import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { Trans } from '@cobliteam/i18n';
import Icon from '@cobliteam/ui/icons';
import { useEffect, useState } from 'react';

const COBLER_DISMISSED_KEY = 'cobler-introspect-dismissed';

const AppIntrospect = ({ children }: { children: React.ReactNode }) => {
  const featureFlags = useFeatureFlags();
  const { getUser, getSession } = useUser();
  const [isDismissed, setIsDismissed] = useState(false);

  // Check if user is a cobler and feature flag is enabled
  const shouldShowIntrospect = featureFlags.impersonate && !isDismissed;

  // Load dismissed state from sessionStorage on mount
  useEffect(() => {
    const dismissed = sessionStorage.getItem(COBLER_DISMISSED_KEY) === 'true';
    setIsDismissed(dismissed);
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(COBLER_DISMISSED_KEY, 'true');
    setIsDismissed(true);
  };

  if (!shouldShowIntrospect) {
    return <>{children}</>;
  }

  const user = getUser();
  const session = getSession();
  const fleet = session.fleet;

  return (
    <div className='relative min-h-screen'>
      {/* Yellow border around the entire app */}
      <div className='pointer-events-none fixed inset-0 z-[9999] rounded-none border-4 border-attention-9' />

      {/* Main content */}
      <div className='relative z-10'>{children}</div>

      {/* Bottom banner with user and company info */}
      <div className='fixed right-0 bottom-0 left-0 z-[10000] px-4'>
        <div className='mx-auto flex w-fit items-center justify-between'>
          <div className='relative flex items-center gap-3 bg-attention-5 px-3'>
            <div className='flex items-center gap-2 py-1 text-gray-11'>
              <Icon name='user' className='h-5 w-5' />
              <span className='font-medium'>
                <Trans
                  ns='ui-business'
                  i18nKey='introspect.impersonating_user'
                  components={{ strong: <strong className='text-gray-12' /> }}
                  values={{ user: user.email, company: fleet.name }}
                />
              </span>
              <div className='ml-3 cursor-pointer rounded-full bg-white' onClick={handleDismiss}>
                <Icon name='x' className='h-5 w-5' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppIntrospect;
